import {useDispatch} from "react-redux";
import {useParams} from "react-router-dom";
import {useState, useEffect} from "react";
import {CreateStackRequestDto} from "ps-letter-mgmtrest-client";
import {createStackRequest, createSummary, updateSummary} from "../../store/app/app.slice";
import {Form, InputNumber, message, Modal, Result, Select} from "antd";
import {CreateSummaryDto} from "ps-letter-mgmtrest-client";
import TextArea from "antd/es/input/TextArea";
import { Checkbox } from "antd";
import {getTopicsOptions, getTopicsOptionsUrdu} from "../helper/labelHelper";
import {SummaryDto} from "ps-letter-mgmtrest-client";

const { Option } = Select;
export default function CreateSummaryDialog(props) {

    const dispatch = useDispatch();

    const [topics, setTopics] = useState(() => {
        if (props.summary && props.summary.topics) {
            return Array.isArray(props.summary.topics) ? props.summary.topics : Array.from(props.summary.topics);
        }
        return props?.topic ? [props.topic] : [];
    });
    const [titleUrdu, setTitleUrdu] = useState(props.summary?.titleUrdu || "");
    const [needPlaceForAdvice, setNeedPlaceForAdvice] = useState(props.summary?.needPlaceForAdvice || false);

    useEffect(() => {
        if (props.summary) {
            setTitleUrdu(props.summary.titleUrdu || "");
            setNeedPlaceForAdvice(props.summary.needPlaceForAdvice || false);
            setTopics(
                props.summary.topics
                    ? Array.isArray(props.summary.topics) ? props.summary.topics : Array.from(props.summary.topics)
                    : []
            );
        } else {
            setTitleUrdu("");
            setNeedPlaceForAdvice(false);
            setTopics(props?.topic ? [props.topic] : []);
        }
    }, [props.summary, props.topic]);

    const hideModal = () =>  {
        props.onHideModal()
    }
    
    const handleOk = () =>  {
        if (!topics || topics.length === 0) {
            message.error({content: "Please select at least one topic"});
            return;
        }
        if(props.summary)
        {
            const summary = {
                ...props.summary,
                titleUrdu: titleUrdu,
                titleEnglish: "",
                topics: topics,
                needPlaceForAdvice: needPlaceForAdvice
            }
            dispatch(updateSummary({
                finalData: {
                    summary: summary
                },
                callbackSuccess: (result) => {
                    if (props.onSummaryUpdated) {
                        props.onSummaryUpdated(result);
                    }
                    hideModal();
                },
                callbackError: (error) => {
                    message.error({content: JSON.stringify(error)})
                },
            }));
        }
        else{
            const summary = {
                titleUrdu: titleUrdu,
                titleEnglish: "",
                topics: topics,
                needPlaceForAdvice: needPlaceForAdvice
            }
            dispatch(createSummary({
                finalData: {
                    summary: summary
                },
                callbackSuccess: (result) => {
                    if (props.onSummaryCreated) {
                        props.onSummaryCreated(result);
                    }
                    hideModal();
                },
                callbackError: (error) => {
                    message.error({content: JSON.stringify(error)})
                },
            }));
        }
    }
    
    // Debug logging
    
    return <Modal
            open={props.showModal}
            title={props.summary ? "Update Summary" : "Create a new Summary"}
            onOk={handleOk}
            okText={"Ok"}
            onCancel={hideModal}
            width={1000}
        >
        <Form.Item label="Summary title in Urdu">
            <TextArea className={"arabic-font arabic-font-edit"} rows={6} size={"large"} value={titleUrdu}
                         onChange={e => setTitleUrdu(e.target.value)}/>
        </Form.Item>

        <Form.Item label="Need Place for Advice">
            <Checkbox checked={needPlaceForAdvice} onChange={e => setNeedPlaceForAdvice(e.target.checked)}>
                Add extra lines into Word Document
            </Checkbox>
        </Form.Item>
            

            <Form.Item label="Topics">
                <Select
                    mode="multiple"
                    style={{width: '100%'}}
                    allowClear
                    popupClassName={"arabic-font arabic-font-edit"}
                    className={"arabic-font arabic-font-extra-small"}
                    placeholder={"Choose Topics"}
                    value={topics}
                    onChange={setTopics}
                >
                    {getTopicsOptionsUrdu()}
                </Select>
            </Form.Item>
        </Modal>
}